module.exports = __webpack_public_path__ + "img/31.3866d0bb.jpg";